import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { hasClass, addClass, removeClass, listen } from "dom-helpers";
import { CSSTransitionPortal } from "sprout-ui-dom/dist/Portal";
import { Box, Flex } from "sprout-ui-primitives";
import { themeGet, media } from "sprout-ui-theme";
const Wrapper = styled(Box)`
  z-index: 105;
`;
const fixed = css`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 101;

  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;

  [class*="dialog-enter-"] & {
    opacity: 1;
  }
`;
const Backdrop = styled(Box)`
  ${fixed};
  background: ${themeGet("colors.black.10")};
`;
const Content = styled(Box)`
  ${fixed};
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  ${({ dialogStyles  })=>dialogStyles || null};
`;
const Card = styled(Flex)`
  flex-direction: column;
  background: ${themeGet("colors.white.100")};

  ${({ fullScreen  })=>!fullScreen ? css`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          min-width: 280px;
          max-width: 384px;
          width: calc(100% - 32px);
          box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
            0px 24px 38px 3px rgba(0, 0, 0, 0.14),
            0px 9px 46px 8px rgba(0, 0, 0, 0.12);
          border-radius: 6px;
        ` : css`
          width: 100%;
          height: 100%;

          ${Array.isArray(fullScreen) ? fullScreen : null};

          ${media.up("small")} {
            height: auto;
            border-radius: 6px;
            box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
              0px 24px 38px 3px rgba(0, 0, 0, 0.14),
              0px 9px 46px 8px rgba(0, 0, 0, 0.12);
            max-width: 448px;
            margin-top: 56px;
            margin-bottom: 56px;
            margin-left: auto;
            margin-right: auto;
            overflow: hidden;
          }

          ${media.up("medium")} {
            margin-top: 64px;
            margin-bottom: 64px;
          }
        `};
`;
const onEnter = ()=>{
    if (hasClass(document.body, "overlay")) return;
    addClass(document.body, "overlay");
};
let Dialog = class Dialog extends Component {
    componentDidMount() {
        const { open  } = this.props;
        if (open) this.handleOpen();
    }
    componentDidUpdate(prevProps) {
        const { open  } = this.props;
        if (!prevProps.open && open) this.handleOpen();
        if (prevProps.open && !open) this.handleClose();
    }
    componentWillUnmount() {
        if (hasClass(document.body, "overlay")) this.handleExited();
        const { open  } = this.props;
        if (open) this.off();
    }
    handleOpen() {
        this.off = listen(document, "keydown", this.handleDocumentKeyDown);
    }
    handleClose() {
        this.off();
    }
    handleDocumentKeyDown(event) {
        const { onRequestClose  } = this.props;
        if (event.key === "Escape") onRequestClose(event);
    }
    handleBackdropClick(event) {
        const { onRequestClose  } = this.props;
        if (event.target === event.currentTarget) onRequestClose(event);
    }
    handleExited() {
        const { location  } = this.props;
        const isModal = location.state && location.state.modal;
        if (document.querySelectorAll("[data-sprout-overlay]").length === 1 && !isModal) removeClass(document.body, "overlay");
    }
    render() {
        const { open , children , fullScreen , dialogStyles , noCard  } = this.props;
        return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
            open: open,
            onEnter: onEnter,
            onExited: this.handleExited,
            classNames: "dialog",
            timeout: {
                enter: 225,
                exit: 225
            },
            children: /*#__PURE__*/ _jsxs(Wrapper, {
                "data-sprout-overlay": "true",
                children: [
                    /*#__PURE__*/ _jsx(Backdrop, {}),
                    /*#__PURE__*/ _jsx(Content, {
                        onClick: this.handleBackdropClick,
                        fullScreen: fullScreen,
                        dialogStyles: dialogStyles,
                        children: !noCard ? /*#__PURE__*/ _jsx(Card, {
                            fullScreen: fullScreen,
                            children: children
                        }) : children
                    })
                ]
            })
        });
    }
    constructor(){
        super();
        this.handleBackdropClick = this.handleBackdropClick.bind(this);
        this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
        this.handleExited = this.handleExited.bind(this);
    }
};
Dialog.propTypes = {
    open: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    fullScreen: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.array
    ]),
    noCard: PropTypes.bool,
    dialogStyles: PropTypes.oneOfType([
        PropTypes.array
    ]),
    location: PropTypes.shape({
        state: PropTypes.shape({
            modal: PropTypes.bool
        })
    }).isRequired
};
export default withRouter(Dialog);
